import { Role } from 'auth';
import { useMemo, useState } from 'react';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { CustodyValidationTab } from '@/modules/admin-dashboard/components/CustodyValidationTab.tsx';
import { PageLayout, TabItem, Tabs } from 'ui';

enum ValidationTab {
  Custody = 'custody',
}

const AdminValidation = () => {
  const [activeTab, setActiveTab] = useState<ValidationTab>(ValidationTab.Custody);

  const tabs = useMemo<TabItem<ValidationTab>[]>(
    () => [
      {
        name: ValidationTab.Custody,
        label: 'Custody',
        container: <CustodyValidationTab />,
      },
    ],
    [],
  );

  return (
    <PageLayout
      title="Validation"
      tabs={tabs}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      tabNameParam="tab"
      contentClassName="!p-0"
    >
      <Tabs items={tabs} activeTab={activeTab} />
    </PageLayout>
  );
};

export default withPrivateAccess(AdminValidation, Role.SR_ADMIN);
